/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Status_Active_LabelInputs */

const en_admin_company_detail_status_active_label = /** @type {(inputs: Admin_Company_Detail_Status_Active_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company is active`)
};

const de_admin_company_detail_status_active_label = /** @type {(inputs: Admin_Company_Detail_Status_Active_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen ist aktiv`)
};

/**
* | output |
* | --- |
* | "Company is active" |
*
* @param {Admin_Company_Detail_Status_Active_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_status_active_label = /** @type {((inputs?: Admin_Company_Detail_Status_Active_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Status_Active_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_status_active_label(inputs)
	return en_admin_company_detail_status_active_label(inputs)
});